import { Flex, Box, Text } from '@cad-arc';
import { getCrossStreetDisplay } from '../../helpers/location-display';
import { LocationStoreView } from '../../types/locations';
import { CommonSize, getOneSizeSmaller } from '../../../common/helpers/utils';
import { Tooltip } from '~/common/components/tooltip';

function LocationDetailRow({
    tooltip,
    text,
    label,
    size,
}: {
    tooltip?: string | null;
    text?: string | null;
    label: string;
    size?: CommonSize;
}) {
    const smallerSize = getOneSizeSmaller(size);

    const textElement = (
        <Text fontSize={smallerSize} color={text ? 'primary' : 'tertiary'}>
            {text ?? 'No Data'}
        </Text>
    );

    return (
        <Flex alignItems="flex-end" gap="2">
            <Text as="span" fontSize={smallerSize} color="tertiary" fontWeight="bold">
                {label}
            </Text>
            <Box fontFamily="jaf-facitweb">
                {tooltip ? (
                    <Tooltip overlay={tooltip ?? undefined}>{textElement}</Tooltip>
                ) : (
                    textElement
                )}
            </Box>
        </Flex>
    );
}

export function LocationDetails({
    selectedLocation,
    size,
}: {
    selectedLocation?: LocationStoreView | null;
    size?: CommonSize;
}) {
    return (
        <Flex flexDir="column" alignItems="flex-start" h="100px" gap="none" pl="2" pt="2">
            <LocationDetailRow
                label="ADDRESS RANGE"
                text={selectedLocation?.rangeName}
                size={size}
            />

            <LocationDetailRow
                label="CROSS STREET"
                text={selectedLocation ? getCrossStreetDisplay(selectedLocation) : null}
                size={size}
            />
            <LocationDetailRow
                label="D-AREA"
                text={selectedLocation?.dispatchArea}
                tooltip={selectedLocation?.dispatchAreaLabel}
                size={size}
            />
        </Flex>
    );
}
